import { FormattedDate, useIntl } from 'react-intl';

import { LightningBolt } from '@/components/icons/lightning-bolt';
import { Typography } from '@/components/ui/typography';
import { isWithinLast24Hours, toDate } from '@/utils/date-util';

import { useChannelsStore } from '../use-channels-store';

function AutomationStatusBanner() {
  const intl = useIntl();
  const channel = useChannelsStore(s => s.lastAutomationChannel);

  if (!channel) return null;

  const isCampaignActive = !!channel.deactivated_at;
  const lastAutomationTriggerAt = toDate(channel.automation_triggered_at);
  const showAutomationTriggeredRecently =
    lastAutomationTriggerAt && isWithinLast24Hours(lastAutomationTriggerAt);

  const getTitle = (isActive: boolean) =>
    isActive
      ? intl.formatMessage({
          defaultMessage: 'Sourcing paused',
        })
      : intl.formatMessage({
          defaultMessage: 'Sourcing resumed',
        });

  const getDescription = (isActive: boolean) =>
    isActive
      ? intl.formatMessage({
          defaultMessage:
            'Sourcing has been paused automatically as we have sufficient applicants in the funnel.',
        })
      : intl.formatMessage({
          defaultMessage:
            'Sourcing has been resumed as we have insufficient applicants in the funnel.',
        });

  if (!lastAutomationTriggerAt || !showAutomationTriggeredRecently) {
    return null;
  }

  return (
    <div className="bg-fx-brand-50 border-fx-brand-600 shadow-base color-fx-primary flex h-12 border-spacing-1 place-items-center justify-start gap-2 rounded-lg border p-2">
      <LightningBolt className="text-fx-primary h-4 w-4" />
      <div className="flex flex-col">
        <Typography variant="body2">
          {getTitle(isCampaignActive)} -{' '}
          <FormattedDate
            value={lastAutomationTriggerAt}
            month="short"
            day="2-digit"
            year="numeric"
          />
        </Typography>
        <Typography variant="body1" className="!text-fx-neutral-600">
          {getDescription(isCampaignActive)}
        </Typography>
      </div>
    </div>
  );
}

export { AutomationStatusBanner };
